<template>
  <div class="back-home-container" v-show="jumpTmdHomeFloatViewShow==='Y'">
    <div
      :class="['nd-drag', { close: !open }]"
      data-sensors-click
      ref="dragDom"
    >
      <div class="back-home-drag" ref='boxDom' @click="backHome" data-sensors-click>
        <p class="home"></p>
        <span>返回首页</span>
        <i class="icon-close" @click.stop="hiddenBackHome"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getKey, setKey } from '../../assets/utils'
export default {
  props: ['y'],
  data () {
    return {
      isDragged: false,
      domLeft: 0,
      domTop: 0,
      initX: 0,
      initY: 0,
      open: true,
      hideShow: false,
      jumpTmdHomeFloatViewShow: '',
      topPosition: 0 // 页面顶部的限制距离
    }
  },
  computed: {
    ...mapState({
      statusBarHeight: (state) => state.statusBarHeight || 0
    }),
    title () {
      const { title } = getKey('userInfo')
      return title
    }
  },
  async mounted () {
    if (getKey('channel') !== 'API-rosewallet') return 
    const { success, data } = await this.rosewalletConfig()
    if (success && data) {
      this.jumpTmdHomeFloatViewShow = data.jumpTmdHomeFloatViewShow
      this.open = getKey('backHome') !== 'N' // 是否显示返回首页按钮
      setTimeout(() => {
        // 顶部距离修正，为确保顶部和底部的DOM加载完成，所以添加一个500ms的延迟
        this.topPosition += this.statusBarHeight
        const navDom = document.querySelector('.nd-navigation')
        if (navDom) {
          this.topPosition += navDom.offsetHeight
        }
        // TODO 这里减去了底部距离，应该还会减去app内部的header距离
        const tabbarDom = document.querySelector('.nd-tabbar')
        if (tabbarDom) {
          pageHeight -= tabbarDom.offsetHeight
        }
      }, 500)
      const dragDom = this.$refs.dragDom
      if (!dragDom) return
      // 页面宽度和高度
      const pageWidth = document.documentElement.clientWidth
      let pageHeight = document.documentElement.clientHeight
      // 拖拽元素宽度和高度
      let dragWidth = dragDom.offsetWidth
      const dragHeight = dragDom.offsetHeight

      // 初始化位置信息
      const dragPosition = this.y 
      const boxDom = this.$refs.boxDom
      if (dragPosition) {
        dragDom.style.top = dragPosition + 'rem'
      } else {
        dragDom.style.left = pageWidth - dragWidth + 'px'
        dragDom.style.top = pageHeight - dragHeight - boxDom.offsetWidth + 'px'
      }

      dragDom.addEventListener('touchstart', (e) => {
        e.stopPropagation()
        dragWidth = dragDom.offsetWidth
        this.isDragged = true
        this.initX = e.touches[0].clientX
        this.initY = e.touches[0].clientY
        this.domLeft = dragDom.offsetLeft
        this.domTop = dragDom.offsetTop
      })
      dragDom.addEventListener('touchmove', (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (this.isDragged) {
          const x = e.touches[0].clientX
          const y = e.touches[0].clientY
          // 鼠标移动的距离
          const offsetX = x - this.initX
          const offsetY = y - this.initY
          // 鼠标移动后元素的新位置
          const newLeft = this.domLeft + offsetX
          const newTop = this.domTop + offsetY

          if (newLeft < 0) {
            dragDom.style.left = 0 + 'px'
          } else if (newLeft > pageWidth - dragWidth) {
            dragDom.style.left = pageWidth - dragWidth + 'px'
          } else {
            dragDom.style.left = newLeft + 'px'
          }
          if (newTop < this.topPosition) {
            dragDom.style.top = this.topPosition + 'px'
          } else if (newTop > pageHeight - dragHeight) {
            dragDom.style.top = pageHeight - dragHeight + 'px'
          } else {
            dragDom.style.top = newTop + 'px'
          }
        }
      })

      dragDom.addEventListener('touchend', () => {
        this.isDragged = false
        dragDom.style.left = `${pageWidth - dragDom.clientWidth}px`
      })
    }
  },
  methods: {
    ...mapActions(['rosewalletConfig']),
    backHome () {
      this.$router.push('/')
    },
    hiddenBackHome () {
      this.open = false
      const dragDom = this.$refs.dragDom
      dragDom.style.left = 'initial'
      setKey('backHome', 'N')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.back-home-container {
  .nd-drag {
    height: 56px;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 999;
    transition: transform 0.3s;
    padding-top: 40px;
    width: fit-content;
    &.close {
      .back-home-drag {
        padding-right: 8px;
        span {
          width: 0;
          margin-left: 0;
        }
        .icon-close {
          width: 0;
          border-left: none;
        }
      }
    }
  }
  .back-home-drag {
    border:1px solid #ddd;
    border-radius: 100px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 8px;
    background: #fff;
    transition: 1s;
    height: 56px;
    .icon-close {
      background: url(./images/btn_a@2x.png) no-repeat center center;
      display: block;
      width:55px;
      height:55px;
      background-size:8px 14px ;
      border-left:1px solid #ddd;
      transition: 1s;
    }
    .home {
      width:40px;
      height:40px;
      background: url(./images/btn_home@2x.png) no-repeat center center;
      display: block;
      background-size: 40px 40px;
    }
    span {
      word-break: keep-all;
      margin-left: 8px;
      font-size: 24px;
      color: #333333;
      transition: 1s;
      overflow: hidden;
      width: 110px;
    }
  }
}
</style>
